export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  postCount: number;
  todayCount: number;
}

export const categories: Category[] = [
  {
    slug: 'tech',
    name: '技术交流',
    icon: 'ri-code-s-slash-line',
    description: '编程开发、前端后端、人工智能等技术话题讨论与经验分享',
    postCount: 48520,
    todayCount: 156,
  },
  {
    slug: 'life',
    name: '生活杂谈',
    icon: 'ri-home-heart-line',
    description: '日常生活、美食旅行、家居装修等生活话题交流',
    postCount: 62380,
    todayCount: 203,
  },
  {
    slug: 'entertainment',
    name: '影视娱乐',
    icon: 'ri-movie-2-line',
    description: '电影剧集、综艺节目、明星八卦等娱乐内容讨论',
    postCount: 38900,
    todayCount: 178,
  },
  {
    slug: 'gaming',
    name: '游戏电竞',
    icon: 'ri-gamepad-line',
    description: '热门游戏攻略、电竞赛事、游戏资讯交流区',
    postCount: 52100,
    todayCount: 245,
  },
  {
    slug: 'study',
    name: '学习资料',
    icon: 'ri-book-open-line',
    description: '考试考证、技能学习、书籍推荐等学习资源分享',
    postCount: 35600,
    todayCount: 98,
  },
  {
    slug: 'fun',
    name: '灌水乐园',
    icon: 'ri-emotion-laugh-line',
    description: '轻松闲聊、趣味话题、搞笑段子集中地',
    postCount: 89500,
    todayCount: 420,
  },
  {
    slug: 'photography',
    name: '摄影美图',
    icon: 'ri-camera-lens-line',
    description: '摄影技巧、作品分享、器材讨论与交流',
    postCount: 28400,
    todayCount: 67,
  },
  {
    slug: 'music',
    name: '音乐分享',
    icon: 'ri-music-2-line',
    description: '音乐推荐、乐器交流、歌曲创作与分享',
    postCount: 31200,
    todayCount: 89,
  },
];